export const commentInputLabel = "Enter Comment";
export const commentInputName = "Comment";
export const expiryReasonDropdownLabel =
  "Please give a reason for the Re-audit Status";
export const expiryCommentsLabel = "Add Comments (optional)";
export const expiryCommentsTitle = "Comments";
